// src/pages/MentionsLegales.js
import React from "react";
import "../index.css";

export default function MentionsLegales() {
  return (
    <main className="legal-page">
      <header className="legal-hero">
        <h1>Mentions légales</h1>
        <p>Informations légales relatives au site maximeh.fr</p>
      </header>

      <div className="legal-stack">
        <section className="legal-card">
          <h2>Éditeur du site</h2>
          <p><strong>Maxime HUYLEBROECK</strong></p>
          <p>Entrepreneur Individuel (EI)</p>
          <p>Photographe professionnel</p>
          <p>
            Adresse professionnelle : 23 allée René Peters, 54510 Tomblaine — France
            <br />
            Email : <a href="mailto:contact@maximeh.fr">contact@maximeh.fr</a>
            <br />
            Téléphone : <a href="tel:+33663252202">+33 6 63 25 22 02</a>
          </p>
        </section>

        <section className="legal-card">
          <h2>Responsable de la publication</h2>
          <p><strong>Maxime HUYLEBROECK</strong> — en qualité d’éditeur du site.</p>
        </section>

        <section className="legal-card">
          <h2>Hébergement</h2>
          <p>
            Le site <strong>maximeh.fr</strong> est hébergé par :<br />
            <strong>OVHcloud</strong><br />
            2 rue Kellermann, 59100 Roubaix — France
          </p>
        </section>

        <section className="legal-card">
          <h2>Propriété intellectuelle</h2>
          <p>
            L’ensemble des contenus présents sur le site maximeh.fr (photographies, textes, images,
            graphismes, logo, identité visuelle, structure du site) est protégé par le droit d’auteur
            et demeure la propriété exclusive de Maxime HUYLEBROECK, sauf mention contraire.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication, adaptation ou exploitation,
            totale ou partielle, par quelque procédé que ce soit, sans autorisation écrite préalable,
            est strictement interdite.
          </p>
        </section>

        <section className="legal-card">
          <h2>Données personnelles</h2>
          <p>
            Les informations éventuellement collectées via le site (formulaire de contact) sont
            traitées conformément à la Politique de confidentialité.
          </p>
        </section>
      </div>
    </main>
  );
}